import { render, staticRenderFns } from "./SkeletonInternetAndMobileCard.vue?vue&type=template&id=3dea93eb"
import script from "./SkeletonInternetAndMobileCard.vue?vue&type=script&lang=ts"
export * from "./SkeletonInternetAndMobileCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports